import { TranslationKey } from './../../../../../types/translation/TranslationKey';
import React, { useContext, useMemo, useState } from 'react';
import { t } from '../../../../../types/translation/Translator';
import { CompanyRoleAssignment } from '../../../../../types/company_role_assignment/companyRoleAssignment';
import { CompanyRoleAssignmentContext } from '../../../../../context/CompanyRoleAssignmentContext';
import { UserContext } from '../../../../../context/UserContext';
import { CompanyContext } from '../../../../../context/CompanyContext';
import Table from '../../../../components/Table';
import FlexPane from '../../../../../VentoryUI/components/common/FlexPane';
import { OrderInput } from '../../../../../types/order/';
import SearchBarWithFilter from '../../../../../VentoryUI/components/common/SearchBarWithFilter';
import { CompanyRoleAssignmentFilter } from '../../../../../VentoryUI/components/filters/CompanyRoleAssignmentFilter';

interface OrderUserPaneProps {
  order: OrderInput;
  setOrder: (order: OrderInput) => void;
  footer: (canUpdate: boolean) => JSX.Element;
}

export default function OrderUserPane({ order, setOrder, footer }: OrderUserPaneProps) {
  const { currentCompany } = useContext(CompanyContext);
  const { companyUsers } = useContext(UserContext);
  const { companyRoles } = useContext(CompanyRoleAssignmentContext);

  const filteredUsers = useMemo(() => {
    return [...companyRoles.values()]
      .flat()
      .filter(r => r.companyId === currentCompany.id && order.assignedTo.includes(r.userId));
  }, [companyRoles, order]);

  const [items, setItems] = useState(filteredUsers);

  const headers = [
    {
      key: 'email',
      name: t(TranslationKey.email).singular.label,
      text: (item: CompanyRoleAssignment) => item.email,
    },
    {
      key: 'name',
      name: t(TranslationKey.firstAndLastName).singular.label,
      text: (item: CompanyRoleAssignment) =>
        `${companyUsers.get(item.userId)?.firstName} ${companyUsers.get(item.userId)?.lastName}` || '',
    },
  ];

  const filter = new CompanyRoleAssignmentFilter(filteredUsers);

  return (
    <FlexPane
      header={
        <SearchBarWithFilter
          filter={filter}
          items={filteredUsers}
          setItems={setItems}
          placeholder={t(TranslationKey.filterUsers).singular.label}
        />
      }
      content={<Table items={items} headers={headers} filter={filter} />}
      footer={footer(false)}
    />
  );
}
